import type { IconData } from '@stacksjs/iconify-core'

export const mapLocationStarPin: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M42 21c0 12.919-13.35 22.128-17.056 24.436a1.77 1.77 0 0 1-1.888 0C19.351 43.128 6 33.919 6 21c0-9.941 8.059-18 18-18s18 8.059 18 18\"/><path d=\"M22.224 11.423c.747-1.439 2.805-1.439 3.551 0l2.156 4.155l4.613.909c1.523.3 2.139 2.145 1.1 3.3L30.36 23.44l.6 4.861c.195 1.584-1.45 2.747-2.878 2.035L24 28.298l-4.082 2.038c-1.427.712-3.073-.451-2.878-2.035l.6-4.861l-3.285-3.654c-1.038-1.154-.422-3 1.1-3.3l4.614-.908z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mapLocationStarPin
